import React from "react";
import "./Pricing.css";

const Pricing = () => {
  const packages = [
    {
      name: "1mg Starter Pack",
      duration: "1 Pre-Loaded Pen",
      price: "£99",
      perWeek: "",
      features: [
        "1 pre-loaded pen",
        "4 x 1mg shots"
      ],
      popular: false
    },
    {
      name: "2mg Standard Pack",
      duration: "1 Pre-Loaded Pen",
      price: "£176",
      perWeek: "",
      features: [
        "1 pre-loaded pen",
        "4 x 2mg shots"
      ],
      popular: true
    },
    {
      name: "8mg Premium Pack",
      duration: "1 Pre-Loaded Pen",
      price: "£227",
      perWeek: "",
      features: [
        "1 pre-loaded pen",
        "4 x 8mg shots",
        "Free shipping"
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Pricing & Packages</h2>
        </div>

        <div className="pricing-grid">
          {packages.map((pkg, index) => (
            <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
              {pkg.popular && <div className="popular-badge">Most Popular</div>}
              <div className="pricing-header">
                <h3 className="package-name">{pkg.name}</h3>
                <p className="package-duration">{pkg.duration}</p>
                <div className="package-price">{pkg.price}</div>
                {pkg.perWeek && <p className="package-per-week">{pkg.perWeek}</p>}
              </div>
              <ul className="package-features">
                {pkg.features.map((feature, idx) => (
                  <li key={idx}>✓ {feature}</li>
                ))}
              </ul>
              <a href="#order" className={`package-cta ${pkg.popular ? 'primary' : 'secondary'}`}>
                Select Package
              </a>
            </div>
          ))}
        </div>

        <div className="pricing-info">
          <div className="info-card">
            <h4>📦 Free Shipping</h4>
            <p>All orders ship within 24 hours. Discreet packaging.</p>
          </div>
        </div>

        <div className="order-prompt">
          <p>Submit an inquiry or order directly via WhatsApp. Our team is here to support your journey.</p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;